"use client";

import { PropsWithChildren, Suspense, useEffect } from "react";
import { CookiesProvider } from "react-cookie";
import { Provider as JotaiProvider, createStore } from "jotai";
import { GoogleOAuthProvider } from "@react-oauth/google";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
// import { AbstractIntlMessages, NextIntlClientProvider } from "next-intl";

import { Popup } from "~/client/components";
import { IpContext } from "~/client/hooks";
import { GlobalStyles } from "~/client/styles";

import packageJson from "../../package.json";

import { PostHogPageView } from "./PostHogPageView";

if (!process.env.NEXT_PUBLIC_POSTHOG_KEY)
	throw new Error("NEXT_PUBLIC_POSTHOG_KEY is undefined");

if (typeof window !== "undefined")
	posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
		api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
		person_profiles: "always",
		loaded: posthog => {
			if (process.env.NODE_ENV !== "production") posthog.debug();
		}
	});

const store = createStore();

interface ProviderProps {
	readonly ip: string | null;
	// readonly locale: string;
	// readonly messages: AbstractIntlMessages;
}

export const Providers = ({
	children,
	ip,
	// locale,
	// messages
}: PropsWithChildren<ProviderProps>) => {
	if (!process.env["NEXT_PUBLIC_GOOGLE_CLIENT_ID"])
		throw new Error("NEXT_PUBLIC_GOOGLE_CLIENT_ID is undefined");

	useEffect(() => console.log(`You are running Vita v${packageJson.version}`), []);

	useEffect(() => {
		console.log(`
          learnlearnle      arnlearnlearn     
       learnlearnlearnl   earnlearnlearnlea   
      rnlearnlearnlear  nlearnlearnlearnlearn 
     learnlea      r   nlearnle       arnlearn
     learnle          arnlearn         learnle    Passionate about education? Come work at Vita!
     arnlear         nlearnle          arnlear           Email rich@vitalearning.ca
     nlearnle      arnlearnlear      nlearnlea
      rnlearnlearnlearnlearnlearnlearnlearnle 
       arnlearnlearnlearn learnlearnlearnle   
          arnlearnlear      nlearnlearnle     
		`);
	}, []);

	return (
		<CookiesProvider>
			<GoogleOAuthProvider clientId={process.env["NEXT_PUBLIC_GOOGLE_CLIENT_ID"]}>
				<PostHogProvider client={posthog}>
					<JotaiProvider store={store}>
						<IpContext value={ip}>
							<Suspense>
								<PostHogPageView />
							</Suspense>
							<GlobalStyles />
							{/* <NextIntlClientProvider locale={locale} messages={messages}> */}
							{children}
							{/* </NextIntlClientProvider> */}
							<Popup />
						</IpContext>
					</JotaiProvider>
				</PostHogProvider>
			</GoogleOAuthProvider>
		</CookiesProvider>
	);
};